import apiSlice from "../api/apiSlice";

export const simulatorApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* POST */
    addNewSimulatedCommunity: builder.mutation({
      query: ({
        basicInfo,
        members,
        resources,
        resp,
        meters,
        contracts,
        fixedBilateralPrices,
        loadsFiles = [],
        dsoFile = [],
      }) => {
        const formData = new FormData();

        formData.append("basic_info", JSON.stringify(basicInfo));
        formData.append("members", JSON.stringify(members));
        formData.append("resources", JSON.stringify(resources));
        formData.append("resp", JSON.stringify(resp));
        formData.append("meters", JSON.stringify(meters));
        formData.append("contracts", JSON.stringify(contracts));
        formData.append("fixed_bilateral_prices", JSON.stringify(fixedBilateralPrices));

        loadsFiles.forEach((file) => {
          formData.append(`loads_files`, file);
        });

        if (dsoFile.length > 0) {
          formData.append("dso_file", dsoFile[0]);
        }

        return {
          url: `/simulator`,
          method: "POST",
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: [{ type: "Community" }],
    }),

    runSimulationTask: builder.mutation({
      query: ({ communityId, taskName, startDate, endDate, useDsoMeasurements }) => ({
        url: `/simulator/${communityId}/simulationtask/${taskName}`,
        method: "POST",
        cache: "no-cache",
        body: {
          start_date: startDate,
          end_date: endDate,
          use_dso_measurements: useDsoMeasurements,
        },
      }),
    }),
  }),
});

export const { useAddNewSimulatedCommunityMutation, useRunSimulationTaskMutation } =
  simulatorApiSlice;
